<ng-template #content let-modal>
  <div trapFocus>
    <div class="modal-header ml-auto align-items-center">
      <!-- <span class="modal-item">Cogito</span>
        <span class="modal-item">Ergo</span>
        <span class="modal-item">Action secondary</span>
        <span class="modal-item"><button type="button" class="btn btn-lg text-uppercase">Action</button></span> -->
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3 validate-lb" id="lightbox" style="height: 75vh">
      <div
        class="row"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
        "
      >
        <div class="col-12 col-md-6 offset-md-3" *ngIf="!decisionSent">
          <div class="h2-eq">{{ texts?.isDecisionDoneText }}</div>

          <div
            class="switch-container"
            style="margin-top: 50px"
            [ngClass]="'switch-container-' + cssColor"
            *ngFor="let product of texts.productNames"
          >
            <label class="switch">
              <input type="checkbox" (change)="oncheckboxchange(product)" />
              <span class="slider round"></span>
            </label>
            {{ product }}
          </div>
          <div
            class="h2-eq"
            style="text-align: center; color: red; margin-top: 50px"
          >
            <button
              class="btn-validate text-uppercase"
              [disabled]="!allValidated"
              (click)="sendDecision()"
            >
              <span [hidden]="isDemo">{{ texts?.sendDecisionText }}</span>
              <span [hidden]="!isDemo">{{ texts?.runDecisionText }}</span>
            </button>
            <button
              class="btn-validate text-uppercase"
              (click)="modal.dismiss('Cross click')"
            >
              {{ texts?.cancelText }}
            </button>
          </div>
        </div>
        <div
          class="col-12 col-md-6 offset-md-3"
          *ngIf="
            decisionSent &&
            negativeCashLeft !== 0 &&
            (!displayCancelConfirm || !decisionConfirmed)
          "
        >
          <div class="h2-eq" style="text-align: center; color: red">
            {{ texts?.negativeCashLeft1Text }} {{ negativeCashLeft }}
            {{ texts?.negativeCashLeft2Text }}
          </div>
          <div
            class="h2-eq"
            style="text-align: center; color: red; margin-top: 50px"
          >
            <button
              class="btn-validate text-uppercase"
              (click)="modal.dismiss('Cross click')"
            >
              {{ texts?.cancelText }}
            </button>
            <button
              class="btn-validate text-uppercase"
              [hidden]="!displayCancelConfirm"
              (click)="confirmDecision()"
            >
              {{ texts?.confirmDecisionText }}
            </button>
          </div>
        </div>

        <div
          class="col-12 col-md-6 offset-md-3"
          *ngIf="
            decisionConfirmed &&
            (negativeCashLeft === 0 || displayCancelConfirm)
          "
        >
          <div class="h2-eq" style="text-align: center" [hidden]="isDemo">
            {{ texts?.thankYouText }}
          </div>
          <div
            class="h2-eq"
            style="text-align: center"
            [hidden]="!isDemo || runModelEnded"
          >
            <img src="img/spinner.svg" /><br />
            {{ texts?.modelRunningText }}
          </div>
          <div
            class="h2-eq"
            style="text-align: center"
            [hidden]="!isDemo || !runModelEnded"
          >
            {{ texts?.modelHasRunText }}
          </div>
          <div
            class="h2-eq"
            style="text-align: center; color: red; margin-top: 50px"
            [hidden]="!isDemo || !runModelEnded"
          >
            <button
              class="btn-validate text-uppercase"
              (click)="modal.dismiss('Cross click')"
            >
              {{ texts?.viewResultText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-uppercase"></div>
  </div>
</ng-template>
